import { ActionFunctionArgs } from "@remix-run/node";
import { assert, jauntPost } from "~/lib";
import { z } from "zod";
import { parseRequestForm } from "~/lib/form-parse";

export const StartTimerParams = z.object({
  completeCurrentTimer: z.coerce.boolean(),
  timerStartTime: z.coerce.number().optional(),
});

export type StartTimerParams = z.infer<typeof StartTimerParams>;

export async function action({ params, request }: ActionFunctionArgs) {
  assert(typeof params.projectId === "string", "Invalid project id");

  const body = await parseRequestForm(request, StartTimerParams);

  const response = await jauntPost(
    `v0/projects/${params.projectId}/timer/start`,
    request,
    body,
  );

  assert(response.ok, "Failed to start timer", 500);
  return null;
}
